// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SetMealCreate_style_wrapper__uHYLX","meal":"SetMealCreate_style_meal__3JM4h","footer":"SetMealCreate_style_footer__8NOev"};